import { sendTagularEvent } from '../tagular'
import {
  EventName,
  EventPayload,
  FormBrand,
  FormName,
  TagularTrackingBaseEvent,
} from '@mortgage-pos/types'

export type TagularEventFields<E extends TagularTrackingBaseEvent> = Omit<
  E,
  keyof TagularTrackingBaseEvent
>

export type TagularTrackingContext = {
  formId: string
  formName: FormName
  pageName: string
  stepNumber: number
}

export abstract class TagularTrackingService {
  protected readonly formVersion = '1'
  protected readonly formType = 'Lead_Form'

  protected emit<E extends TagularTrackingBaseEvent = TagularTrackingBaseEvent>(
    eventName: EventName,
    context: TagularTrackingContext,
    fields: TagularEventFields<E>
  ) {
    const payload = {
      ...this.buildBase(context),
      ...fields,
    } as EventPayload
    sendTagularEvent(eventName, payload)
  }

  private buildBase({
    formId,
    formName,
    pageName,
    stepNumber,
  }: TagularTrackingContext): TagularTrackingBaseEvent {
    return {
      correlationId: formId,
      formContext: {
        formVersion: this.formVersion,
        formId,
        formName,
        formType: this.formType,
        formBrand: FormBrand.Sage,
      },
      stepContext: {
        stepId: pageName,
        stepNumber,
        stepName: pageName,
      },
      timestamp: new Date().toISOString(),
    }
  }
}
